module.exports = __webpack_public_path__ + "img/EC21.33801d93.png";